<template>
  <b-container>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Complexen beheer</b-card-title>
      </b-card-header>
      <b-tabs card>
        <b-tab title="Complexen zonder units">
          <b-card-text>Onderstaande {{ legecomplexen.length }} hebben geen units.</b-card-text>
          <b-table
            :fields="[{label:'Afbeelding',key:'Th'},{label:'Complexnummer',key: 'Nr'},{label:'Relatie',key:'Re'},{label:'Huismeester',key:'Hu'},{label:'Aantal units',key:'Qu'},{label:'Acties',key:'Acties'}]"
            :busy="complexen.length == 0"
            :items="legecomplexen"
            caption-top="true"
            caption="NB. Complexen waar geen units aan gekoppeld zijn kunnen zonder problemen worden verwijderd."
            small
            fixed
            bordered
          >
            <template #cell(Hu)="row">
              {{ row.item.Hu.Na }} {{ row.item.Hu.Te }}
            </template>
            <template #cell(Th)="row">
              <b-img
                :src="row.item.Th == '/img/no-img.jpg' ? 'https://res.cloudinary.com/transplan/image/upload/v1598353187/no-img_tumjza.jpg' : row.item.Th"
                width="50+"
              />
            </template>
            <template #cell(Acties)="row">
              <b-button
                variant="danger"
                size="sm"
                :disabled="verwijderBezig == row.item.Id"
                @click="verwijderComplex(row.item)"
              >
                <b-spinner
                  v-if="verwijderBezig == row.item.Id"
                  small
                />
                Verwijder
              </b-button>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-container>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
export default {
  mixins: [serviceMixin],
  data() {
    return {
      complexen: [],
      groep: "D",
      error: null,
      verwijderBezig: null,
    };
  },
  computed: {
    legecomplexen: function () {
      return this.complexen.filter((item) => item.Qu == 0);
    },
  },
  mounted() {
    this.getComplexen();
  },
  methods: {
    getComplexen() {
      var vm = this;
      this.get("/complexen/" + this.groep)
        .then(function (response) {
          console.log(response);
          vm.complexen = response.data.complexen;
        })
        .catch(function (error) {
          vm.error = error;
        });
    },
    verwijderComplex(complex) {
      var vm = this;
      this.$bvModal
        .msgBoxConfirm(
          "Weet je zeker dat je complex " + complex.Nr + " wilt verwijderen? De afbeelding wordt ook verwijderd.",
          {
            title: "Complex verwijderen",
            okVariant: "danger",
            okTitle: "Verwijderen",
            cancelTitle: "Annuleren",
            centered: true,
          }
        )
        .then(function (bevestigd) {
          if (!bevestigd) return;
          vm.verwijderBezig = complex.Id;
          vm.delete("/complex/" + complex.Id)
            .then(function () {
              // Lijst reageert op succesvolle verwijdering
              vm.complexen = vm.complexen.filter(
                (item) => item.Id != complex.Id
              );
              vm.$bvToast.toast("Complex " + complex.Nr + " is verwijderd.", {
                title: "Verwijderd",
                variant: "success",
                solid: true,
              });
            })
            .catch(function (error) {
              var boodschap =
                error.response && error.response.data && error.response.data.error
                  ? error.response.data.error
                  : "Verwijderen mislukt.";
              vm.$bvToast.toast(boodschap, {
                title: "Fout",
                variant: "danger",
                solid: true,
              });
            })
            .finally(function () {
              vm.verwijderBezig = null;
            });
        });
    },
  },
};
</script>